/** @format */

import { useState } from "react";
import {
  BvnIcon,
  ContactIcon,
  DobIcon,
  EmailIcon,
  LocationIcon,
    NationalIdIcon,
  CopyIcon
} from "../../components/common/IconComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

const ProfileDetails = ({ applicant }) => {

  const [copyStatus, setCopyStatus] = useState({});

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    setCopyStatus({ [value]: true });
    setTimeout(() => {
      setCopyStatus({});
    }, 1000);
  };

  

  const { Date, nationalId, bvn, contact, email, address } = applicant;

  return (
    <div className="md:w-1/2 p-2">
      <div className="mb-8">
        <table className="w-full">
          <tbody>
            <tr className="hover:bg-[#F5F5FF]">

              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <DobIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">Date Of Birth:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(Date)}
              >
                {Date}
                {copyStatus[Date] ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-green-500">
                    <CopyIcon />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-700">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
            <tr className="hover:bg-[#F5F5FF]">
              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <NationalIdIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">National ID No:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(nationalId)}
              >
                {nationalId}
                {copyStatus[nationalId] ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-green-500">
                    <CopyIcon />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-100">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
            <tr className="hover:bg-[#F5F5FF]">
              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <BvnIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">BVN:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(bvn)}
              >
                {bvn}
                {copyStatus[bvn] ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-green-500">
                    <CopyIcon />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-100">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
            <tr className="hover:bg-[#F5F5FF]">
              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <ContactIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">Contact:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(contact)}
              >
                {contact}
                {copyStatus[contact] ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-green-500">
                    <CopyIcon />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-100">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
            <tr className="hover:bg-[#F5F5FF]">
              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <EmailIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">Email address:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(email)}
              >
                {email}
                {copyStatus[email] ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-green-500">
                    <CopyIcon />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-100">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
            <tr className="hover:bg-[#F5F5FF]">
              <td className="p-2">
                <div className="flex items-center text-[#616161]">
                  <LocationIcon className="mr-2 group-hover:text-blue-500" />
                  <p className="font-thin">Home address:</p>
                </div>
              </td>
              <td
                className="font-thin cursor-pointer relative"
                onClick={() => handleCopy(address)}
              >
                {address}
                {copyStatus[address] ? (
                  <div className="absolute  top-1/2 -translate-y-1/2 text-green-500">
                    <FontAwesomeIcon icon={faCheck} />
                  </div>
                ) : (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-500 opacity-0 group:hover:opacity-100">
                    <FontAwesomeIcon icon={faCopy} />
                  </div>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfileDetails;
